<template>
  <div class="change-evn">
    <slot name="txtBefore"></slot>
    <b-form-group label="Auswahl des Einzelverbindungsnachweises" label-class="visually-hidden" name="evnSelection" v-model="evnSelected_" :disabled="disableInput" v-if="plainRadio">
      <b-form-radio
        v-model="evnSelected_"
        v-for="evn in allEvn"
        :key="evn.key"
        :value=evn.key
        plain
        class="allEvnSelection">{{evn.message}}</b-form-radio>
    </b-form-group>
    <b-form-group name="evnSelection" v-model="evnSelected_" :disabled="disableInput" v-else>
      <b-form-radio
        v-model="evnSelected_"
        v-for="evn in allEvn"
        :key="evn.key"
        :value=evn.key
        class="allEvnSelection">{{evn.message}}</b-form-radio>
    </b-form-group>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'EvnSelect',
  mixins: [
    syncProperty('evnSelected', 'evnSelected_')
  ],
  computed: {
    allEvn: function () {
      return this.$config.evnMap
    }
  },
  props: {
    plainRadio: {
      type: Boolean,
      default: false
    },
    disableInput: {
      type: Boolean,
      default: false
    }
  }
}
</script>
